export default {"src":"/planos/_next/static/media/equifax-pointer-check.6d64d147.svg","height":56,"width":51,"blurWidth":0,"blurHeight":0};